import styled from 'styled-components'

export const TableHead = styled.thead`
  background-color: ${props => props.theme.colors.background.secondary};
  border-color: ${props => props.theme.colors.background.secondary};
  position: sticky;
  top: 0;
  z-index: 1;

  th:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  th:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`

export const TableHeader = styled.th`
  text-align: left;
  color: ${props => props.theme.colors.text.subtle};
  text-transform: uppercase;
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
`

export const CheckboxCell = styled.th`
  width: ${props => props.theme.size.L};
`

export const ProductPositionCell = styled.td`
  width: 10px;
`

export const CaretDownCell = styled.td`
  width: ${props => props.theme.size.S};
`
